import type { PasswordResetVerifyFormSchema } from '@/modules/passwordReset/components/PasswordResetVerifyForm/PasswordResetVerifyForm.types'

export const passwordResetVerifyFormDefaultValues: PasswordResetVerifyFormSchema =
  {
    confirmPassword: '',
    email: '',
    password: '',
    token: '',
  }
